@if (!hideHeader) {
  <app-content-header
    (backEvent)="onBack()"
    [historyBack]="false"
  [headline]="confirmHeadline"></app-content-header>
}

<div class="row">
  <div class="col-md-6 offset-md-3">
    <div class="card text-white bg-danger h-100 card-nb">
      <div class="card-body pb-0">
        <h2 class="text-uppercase text-align-center">
          {{ confirmDetailsHeadline }}
        </h2>
      </div>
      <div class="card-body pt-0 pb-0">
        <div class="container p-0">
          <div>
            {{ confirmDetailsText }}
          </div>
        </div>
        <div class="row mt-3 justify-content-end">
          @if (!hideCancelBtn) {
            <button name="cancel-abort" class="btn btn-link text-light" (click)="onBack()">
              {{ cancelBtn }}
            </button>
          }
          @if (!hideConfirmBtn) {
            <button name="cancel-confirm" class="btn btn-outline-light" (click)="onConfirm()">
              {{ confirmBtn }}
            </button>
          }
        </div>
      </div>
    </div>
  </div>
</div>

@if (!!footerCancelBtnText) {
  <div class="d-flex justify-content-center mt-5">
    <button
      name="cancel-abort"
      class="btn btn-link"
      (click)="onBack()"
      >
      {{ footerCancelBtnText }}
    </button>
  </div>
}
